import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const api = {
  fetchInvoiceFolders: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + "/folders";
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  fetchBuildingInvoices: async (buildingId) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + `/${buildingId}`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  fetchInvoicesToIssue: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + `/to-issue`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  addInvoice: async (invoiceData) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        data: invoiceData, // this is a FormData object
        processData: false, // prevent jQuery from processing the data
        contentType: false, // prevent jQuery from setting content type
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  updateInvoice: async (invoiceData) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "PATCH",
        data: invoiceData, // this is a FormData object
        processData: false, // prevent jQuery from processing the data
        contentType: false, // prevent jQuery from setting content type
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  // ✅ NOWE: pobranie pdf z serwera (jako Blob) + helper do pobrania w przeglądarce
  fetchInvoicePdf: async (invoiceId) => {
    // dostosuj ścieżkę do backendu:
    // np. GET /invoices/file/:invoiceId albo /invoices/:invoiceId/file
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + `/file/${invoiceId}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        xhrFields: {
          responseType: "blob", // Expect binary data
        },
        success: (data, status, xhr) => {
          resolve({
            success: true,
            file: data,
            contentType: xhr.getResponseHeader("Content-Type"),
          });
        },
        error: (xhr) => {
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          });
        },
      });
    });
  },

  fetchInvoiceToIssuePdf: async (invoiceToIssueId, type) => {
    const endpoint =
      BASE_URL +
      ENDPOINT_ROUTES.invoices +
      `/to-issue/file/${invoiceToIssueId}/${type}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        xhrFields: {
          responseType: "blob",
        },
        success: (data, status, xhr) => {
          resolve({
            success: true,
            file: data,
            contentType: xhr.getResponseHeader("Content-Type"),
          });
        },
        error: (xhr) => {
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          });
        },
      });
    });
  },

  // opcjonalny helper: wymusza download bez otwierania nowej karty
  downloadInvoicePdf: async ({ invoiceId, fileName }) => {
    const res = await api.fetchInvoicePdf(invoiceId);
    if (!res?.success) return res;

    const blob = res.file; // <-- u Ciebie blob siedzi w `file`
    if (!(blob instanceof Blob)) {
      return {
        success: false,
        status: res?.status,
        error: "Nieprawidłowa odpowiedź serwera (brak Blob).",
      };
    }

    const finalName = fileName || `invoice_${invoiceId}.pdf`;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = finalName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  },
  downloadInvoiceToIssuePdf: async ({ invoiceToIssueId, type, fileName }) => {
    const res = await api.fetchInvoiceToIssuePdf(invoiceToIssueId, type);
    if (!res?.success) return res;

    const blob = res.file;
    if (!(blob instanceof Blob)) {
      return {
        success: false,
        status: res?.status,
        error: "NieprawidĹ‚owa odpowiedĹş serwera (brak Blob).",
      };
    }

    const finalName =
      fileName || `${type === "zlecenie" ? "zlecenie" : "inne"}_${invoiceToIssueId}.pdf`;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = finalName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  },
  deleteInvoiceToIssue: async (invoiceToIssueId) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.invoices + `/to-issue/${invoiceToIssueId}`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  // --- Faktury cykliczne ---
  fetchRecurringInvoices: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + `/recurring`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  // data: { buildingId, frequency, amount, nextInvoiceDate, description }
  addRecurringInvoice: async (data) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.invoices + `/recurring`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  updateRecurringInvoice: async (recurringInvoiceId, data) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.invoices + `/recurring/${recurringInvoiceId}`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "PATCH",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  deleteRecurringInvoice: async (recurringInvoiceId) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.invoices + `/recurring/${recurringInvoiceId}`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  deleteInvoice : async (invoiceId) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.invoices + `/${invoiceId}`;
    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
};

const invoicesApi = { api };

export default invoicesApi;
